import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { NavLink } from '../interfaces/nav-link.model';
import { LinkDisplayType } from '../enums/link-display-type.enum';

@Injectable({
  providedIn: 'root'
})
export class UiKpiService {
  loadingStateChanged = new Subject<boolean>();
  routeLoadingStateChanged = new Subject<boolean>();
  translationLoadingStateChanged = new Subject<boolean>();
  pageTitleChanged = new Subject<string>();

  constructor(
    private snackbar: MatSnackBar,
    private translateSrv: TranslateService
  ) { }

  showSnackbar(message: string, action: string, duration = 3000, isTranslated = false): void {
    if (isTranslated) {
      this.translateSrv.get(message).subscribe(text => {
        this.snackbar.open(text, action, { duration: duration });
      });
    } else {
      this.snackbar.open(message, action, { duration: duration });
    }
  }

  changeTitle(text: string, isTranslated = true): void {
    if (isTranslated) {
      this.translateSrv.get(text)
        .subscribe(result => {
          this.pageTitleChanged.next(result);
        });
    } else {
      this.pageTitleChanged.next(text);
    }
  }

  translate(key: string): string {
    return this.translateSrv.instant(key);
  }

  getInfoLinks(): NavLink[] {
    return [
      {
        route: "/help",
        icon: "contact_support",
        title: "main.nav.links.help.shortLabel",
        linkLabel: "main.nav.links.help.fullLabel",
        content: "main.nav.links.help.summary",
        display: LinkDisplayType.all
      }
    ];
  }

  getChartsColors(): string[] {
    return [
      '#d32f2f',
      '#424242',
      '#36a2eb',
      '#ff6384',
    ];
  }
  getDoughnutsColors(): string[] {
    return [
      '#36a2eb',
      '#ff6384',
      '#ff9f40',
      '#ffcd56',
      '#666666',
    ];
  }

  lightenHexColor(colorWithTag: string, percent: number): string {
    const color = colorWithTag.substring(1);
    const num = parseInt(color, 16),
      amt = Math.round(2.55 * percent),
      /* tslint:disable:no-bitwise */
      R = (num >> 16) + amt,
      B = (num >> 8 & 0x00FF) + amt,
      G = (num & 0x0000FF) + amt;
    /* tslint:enable:no-bitwise */

    return "#" + (0x1000000
      + (R < 255 ? R < 1 ? 0 : R : 255)
      * 0x10000
      + (B < 255 ? B < 1 ? 0 : B : 255)
      * 0x100
      + (G < 255 ? G < 1 ? 0 : G : 255))
      .toString(16)
      .slice(1);
  }
}
